import React from 'react';
import { USERBALL_CLASS } from '../config';

const UserBall = ({ user, style = {} }) => (
  <div className={`glasslight glassball ${USERBALL_CLASS}`} style={style}>
    <span className="initials">{user}</span>
  </div>
);

export { UserBall };
